import React from 'react'
import SubHeader from '../general/SubHeader';
import AboutMe from '../general/AboutMe';

const About = () => {
    return (
        <>
            <SubHeader message="About Us" />

            <AboutMe />

            {/* Services section */}
            <section className='py-5 bg-light'>
                <div className='container px-lg-5 px-3 text-center'>

                    <p className='sec-subheading'>Benefits</p>
                    <p className='sec-heading'>Get multiple benefits with Omanshi</p>

                    <div className='row mt-4'>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <div className='service-area px-3 py-4'>
                                <i class="fa-solid fa-thumbs-up service-icon"></i>
                                <p className='fw-semibold mt-3 fs-5'>Pre Planning</p>
                                <p className='text-muted'>Omanshi Travels ensures well-organized itineraries with expert guidance, delivering stress-free travel experiences tailored to your needs.</p>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <div className='service-area px-3 py-4'>
                                <i class="fa-solid fa-book-open-reader service-icon"></i>
                                <p className='fw-semibold mt-3 fs-5'>Convenient Booking</p>
                                <p className='text-muted'>Effortlessly book tours, transportation, and accommodations with Omanshi Travels, saving time and ensuring all your travel needs are met.</p>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <div className='service-area px-3 py-4'>
                                <i class="fa-solid fa-car service-icon"></i>
                                <p className='fw-semibold mt-3 fs-5'>Variety Vehicles</p>
                                <p className='text-muted'>We offer a wide range of vehicles, ensuring comfort, safety and convenience for every group size and travel need.</p>
                            </div>
                        </div>


                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* Services section ends */}

        </>
    )
}

export default About
